var map = {
	"./auto1.png": 832,
	"./autodig1.jpg": 3196,
	"./autodig2.jpg": 5995,
	"./autodigs1.jpg": 3841,
	"./autodigs2.jpg": 3494,
	"./autodigs3.jpg": 3603,
	"./banner1.jpg": 2409,
	"./banner2.jpg": 9918,
	"./banner3.jpg": 6379,
	"./banner4.jpg": 3544,
	"./banner5.jpg": 805,
	"./banner6.jpg": 3466,
	"./corrupcion.jpg": 5614,
	"./curso1.png": 4377,
	"./curso2.png": 6194,
	"./curso3.png": 7323,
	"./denuncie.png": 2757,
	"./estadistica.png": 3036,
	"./hello1.jpg": 6421,
	"./hello2.jpg": 698,
	"./hello3.jpg": 2087,
	"./hello4.jpg": 540,
	"./hello5.jpg": 1065,
	"./hello6.jpg": 798,
	"./hello7.jpg": 8843,
	"./logo-paco.svg": 8783,
	"./logo.png": 3153,
	"./logo.svg": 3935,
	"./logo1.png": 3660,
	"./logo2.png": 4343,
	"./logo2_1.png": 6123,
	"./logo2_11.png": 557,
	"./logo2_2.png": 720,
	"./logo2_3.jpg": 2225,
	"./logo2_4.png": 7846,
	"./logo2_5.png": 2943,
	"./logo3.png": 8558,
	"./logo3_1.png": 8298,
	"./logo3_2.png": 3057,
	"./logo4.png": 3121,
	"./rcp.png": 6685,
	"./rcp2.png": 8635,
	"./rcp3.png": 770,
	"./rcp4.png": 3277,
	"./rcplogo.png": 2740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;